import React, { useState, useEffect, useRef } from "react";
import dropdownicon from "../../../Assets/Images/AssignUserToRole/dropdownicon.png";
import { FULL_API_BASE_URL } from "../../../Config/Config";

const SearchSelectedSchool = ({
  onSchoolSelect,
  showError = false,
  isRequired = true,
  initialValue = "",
  disabled = false, // ← NEW
  customWidth,
  customTop,
  minheight,
  Height,
  OverFlow,
}) => {
  const [inputValue, setInputValue] = useState(initialValue);
  const [schools, setSchools] = useState([]);
  const [selectedSchool, setSelectedSchool] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    if (initialValue) {
      setInputValue(initialValue);
    } else {
      setInputValue("");
    }
  }, [initialValue]);

  const onChangeHandler = async (e) => {
    if (disabled) return; // ← NEW
    const searchKey = e.target.value;
    setInputValue(searchKey);
    setSelectedSchool(null);
    setIsOpen(true);

    if (searchKey.trim() === "") {
      setSchools([]);
    } else {
      try {
        const response = await fetch(
          `${FULL_API_BASE_URL}/get-schools-list/?search_key=${searchKey}`
        );
        if (response.ok) {
          const data = await response.json();
          setSchools(data);
        }
      } catch (error) {
        console.error("Error fetching schools:", error);
      }
    }
  };

  const onSelectSchool = (school) => {
    if (disabled) return; // ← NEW
    setInputValue(school.school_name);
    setSelectedSchool(school);
    onSchoolSelect(school);
    setSchools([]);
    setIsOpen(false);
  };

  const handleClear = (e) => {
    if (disabled) return; // ← NEW
    e.stopPropagation();
    setInputValue("");
    setSelectedSchool(null);
    setSchools([]);
    setIsOpen(false);
    onSchoolSelect(null);
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setSchools([]);
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const hasError = showError && isRequired && !selectedSchool && !inputValue;

  return (
    <div
      className="dropdown"
      ref={dropdownRef}
      style={{
        // ← NEW
        pointerEvents: disabled ? "none" : "auto", // ← NEW
        opacity: disabled ? 0.6 : 1, // ← NEW
      }} // ← NEW
    >
      <label>
        School Name
        {isRequired && <span>*</span>}
      </label>

      <div
        className="dropdown-btn"
        style={{
          border: hasError ? "1px solid #ff0000" : "",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          paddingRight: "8px",
          cursor: disabled ? "not-allowed" : "text", // ← NEW
        }}
      >
        <input
          type="text"
          placeholder="Type here to Search..."
          style={{
            width: "100%",
            height: "100%",
            color: "#6A6A6A",
            border: "none",
            outline: "none",
            backgroundColor: "transparent",
            fontSize: "14px",
            cursor: disabled ? "not-allowed" : "text", // ← NEW
          }}
          value={inputValue}
          onChange={onChangeHandler}
          onClick={(e) => {
            if (disabled) return; // ← NEW
            e.stopPropagation();
            setIsOpen(true);
          }}
          disabled={disabled} // ← NEW
        />

        {/* Clear button — only shows when value exists and not disabled */}
        {inputValue &&
          !disabled && ( // ← NEW: added !disabled
            <button
              onClick={handleClear}
              style={{
                background: "none",
                border: "none",
                color: "#6A6A6A",
                fontSize: "10px",
                cursor: "pointer",
                padding: "0 30px",
                flexShrink: 0,
                display: "flex",
                alignItems: "center",
              }}
            >
              ✕
            </button>
          )}

        {/* Dropdown toggle icon — hidden when disabled */}
        {!disabled && ( // ← NEW
          <div
            style={{ display: "flex", alignItems: "center", gap: "5px" }}
            onClick={() => setIsOpen((prev) => !prev)}
          >
            <img src={dropdownicon} alt="dropdown-icon" />
          </div>
        )}
      </div>

      {/* Dropdown list */}
      {isOpen &&
        !disabled &&
        schools.length > 0 && ( // ← NEW: added !disabled
          <div
            className="dropdown-content"
            style={{
              width: customWidth,
              top: customTop,
              maxHeight: minheight,
              height: Height,
              overflow: OverFlow,
            }}
          >
            {schools.map((school) => (
              <div
                key={school.school_id}
                className={`dropdown-item ${
                  selectedSchool?.school_id === school.school_id
                    ? "selected"
                    : ""
                }`}
                onClick={() => onSelectSchool(school)}
              >
                {school.school_name}
              </div>
            ))}
          </div>
        )}
    </div>
  );
};

export default SearchSelectedSchool;
